import React, { useEffect, useState } from 'react' 
import { useSearchParams, useNavigate } from 'react-router-dom'
import { useBnsXiangMuUpdateQuery } from '../store/BnsKeJiApi'
import { Button, Divider, Flex, Modal, Space } from 'antd'
import {  MobileOutlined } from '@ant-design/icons'
import WebMain from './WebMain'
function SketchProject() {
    const [param] = useSearchParams()
    const navigate = useNavigate()
    const bxm_id = param.get('bxm_id')
    const {data,isSuccess} = useBnsXiangMuUpdateQuery({bxm_id:bxm_id},{skip:!bxm_id})
    const [info,setInfo] = useState({
        bxm_content:'',
        children: []
    })
    const [isMobile, setIsMobile] = useState(false)
    const [showMobileModal, setShowMobileModal] = useState(false)
    const [copyButtonText, setCopyButtonText] = useState('复制网址')
    const [copyButtonColor, setCopyButtonColor] = useState('')
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                // 按照yh_name的第一个数字进行排序
                let sorrArr = [...(data.Result.children || [])].sort((a, b) => {
                    // 提取yh_name的第一个数字
                    const getFirstNumber = (name) => {
                        const match = name.match(/\d+/);
                        return match ? parseInt(match[0]) : 0;
                    };
                    
                    const numA = getFirstNumber(a.yh_name);
                    const numB = getFirstNumber(b.yh_name);
                    
                    return numA - numB;
                });
                
                setInfo({
                    bxm_content:data.Result.bxm_content,
                    bxm_name:data.Result.bxm_name,
                    bxm_dept_id:data.Result.bxm_dept_id,
                    bxm_dept_name:data.Result.bxm_dept_name,
                    bxm_ctime:data.Result.bxm_ctime,
                    bxm_cname:data.Result.bxm_cname,
                    bxm_num:data.Result.bxm_num,
                    children: sorrArr,
                })
            }
        }
    },[data,isSuccess])

    // 移动端检测
    useEffect(() => {
        const checkMobile = () => {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent.toLowerCase());
            const isSmallScreen = window.innerWidth <= 768;
            
            const mobileDetected = isMobileDevice || isSmallScreen;
            setIsMobile(mobileDetected);
            
            if (mobileDetected) {
                setShowMobileModal(true);
            }
        };

        checkMobile();
        
        // 监听窗口大小变化
        const handleResize = () => {
            checkMobile();
        };
        
        window.addEventListener('resize', handleResize);
        
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [])

    // 复制网址功能
    const handleCopyUrl = () => {
        navigator.clipboard.writeText(window.location.href).then(() => {
            // 复制成功
            setCopyButtonText('已复制！');
            setCopyButtonColor('#52c41a');
            setTimeout(() => {
                setCopyButtonText('复制网址');
                setCopyButtonColor('');
                setShowMobileModal(false);
            }, 1500);
        }).catch(() => {
            // 复制失败，使用备用方案
            const textArea = document.createElement('textarea');
            textArea.value = window.location.href;
            document.body.appendChild(textArea);
            textArea.select();
            document.execCommand('copy');
            document.body.removeChild(textArea);
            
            setCopyButtonText('已复制！');
            setCopyButtonColor('#52c41a');
            setTimeout(() => {
                setCopyButtonText('复制网址');
                setCopyButtonColor('');
                setShowMobileModal(false);
            }, 1500);
        });
    };

    return (
        <WebMain>
            {/* 移动端提示弹窗 */}
            <Modal
                title={
                    <div style={{display:'flex',alignItems:'center'}}>
                        <MobileOutlined style={{marginRight:'8px',color:'#ff4d4f'}} />
                        <span>移动端访问提示</span>
                    </div>
                }
                open={showMobileModal}
                onCancel={() => setShowMobileModal(false)}
                footer={[
                    <Button 
                        key="copy" 
                        type="primary" 
                        onClick={handleCopyUrl}
                        style={{backgroundColor: copyButtonColor}}
                    >
                        {copyButtonText}
                    </Button>
                ]}
                centered
                width={isMobile ? '90%' : 400}
                maskClosable={false}
                style={{
                    top: isMobile ? '50%' : undefined,
                    transform: isMobile ? 'translateY(-50%)' : undefined
                }}
                styles={{
                    body: {
                        padding: isMobile ? '20px 15px' : '24px'
                    }
                }}
            >
                <div style={{textAlign:'center',padding:'20px 0'}}>
                    <div style={{fontSize:'16px',color:'#666',lineHeight:'1.6'}}>
                        检测到您正在使用移动设备访问此页面。
                    </div>
                    <div style={{fontSize:'16px',color:'#ff4d4f',fontWeight:'bold',marginTop:'15px'}}>
                        请复制网址到电脑浏览器观看，以获得更好的体验。
                    </div>
                    <div style={{marginTop:'20px',padding:'15px',backgroundColor:'#f5f5f5',borderRadius:'8px'}}>
                        <div style={{fontSize:'14px',color:'#999',marginBottom:'8px'}}>当前网址：</div>
                        <div style={{fontSize:'12px',color:'#666',wordBreak:'break-all'}}>
                            {window.location.href}
                        </div>
                    </div>
                </div>
            </Modal>

            <div style={{width:'100%',display:'flex',justifyContent:'center',flexDirection:'column',alignItems:'center'}}>
                <h1 style={{textAlign:'center',color:'#fff'}}>{info.bxm_name}</h1>
                <Divider style={{color:'#fff'}}>项目说明</Divider>
                <div style={{maxWidth:"1280px",minWidth:"1280px",backgroundColor:'#fff',padding:'20px',borderRadius:'10px',marginTop:"1px"}}  dangerouslySetInnerHTML={{__html:info.bxm_content}}></div>
                {/* 客户端列表部分 */}
                <Divider style={{color:'#fff'}}>客户端</Divider>
                <div style={{marginBottom:'2px',maxWidth:"1280px",minWidth:"1280px",}}>
                    {info.children && Array.isArray(info.children) && info.children.map((item,index)=>(
                        <div 
                            key={index} 
                            style={{
                                backgroundColor:'#fff',
                                padding:'20px',
                                borderRadius:'10px',
                                marginBottom:'10px',
                                border:'1px solid #f0f0f0'
                            }}
                        >
                            <Flex justify='space-between' align='start'>
                                <Space align='start' size='large'>
                                    <img 
                                        src={`/api/assets/images/application/${item.yh_image}`} 
                                        alt='' 
                                        style={{width:'140px',height:'140px',borderRadius:'8px',objectFit:'cover'}} 
                                        onError={(e) => {
                                            e.target.src = '/img/home/logo.png'; // 默认图片路径
                                        }}
                                    />
                                    <div>
                                        <div style={{marginBottom:'10px'}}>                                    
                                            <span style={{fontSize:'20px',fontWeight:'bold'}}>{item.yh_name}</span>
                                        </div>
                                        <div dangerouslySetInnerHTML={{__html:item.yh_content}} style={{color:'#666',lineHeight:'1.6'}}></div>
                                    </div>
                                </Space>
                                <Button 
                                    type="primary"
                                    size="small"
                                    onClick={() => {
                                        navigate(`/SketchClient?yh_id=${item.yh_id}&yh_name=${item.yh_name}&bxm_id=${bxm_id}&bxm_name=${info.bxm_name}`,'客户端详情')
                                    }}    
                                >查看详情</Button>     
                            </Flex>
                        </div>
                    ))}
                </div> 
            </div>
        </WebMain>
    )
}

export default SketchProject